<template>
  <div class="flex min-h-screen flex-col bg-background">
    <Header @openDrawer="showSideDrawer = true" />

    <NavBar
      v-if="$features?.brands || $features?.bundles || $features?.categories"
      class="hidden md:!flex"
    />
    <LazyMobileNav v-if="$device.isMobile" v-model:is-open="showSideDrawer" />
    <div class="block h-[0.5px] bg-neutral-400 md:!hidden" />

    <nav
      v-if="!hideBreadcrumb && breadcrumbItems.length > 0"
      class="px-page_padding py-2.5 md:py-6"
    >
      <Breadcrumb class="capitalize" :items="breadcrumbItems" />
    </nav>

    <main class="flex grow flex-col">
      <slot />
    </main>

    <!--TODO: modify show footer condition when the specs are added -->
    <LazyFooter
      hydrate-on-visible
      show_primary_footer
      :quickLinks
      :show_secondary_footer="true"
    />
  </div>
</template>

<script setup lang="ts">
import Header from "~/components/informative/Organism/Header/index.vue";
import NavBar from "~/components/informative/Organism/NavBar/Desktop.vue";
import useBrands from "~/composables/product/useBrands";
import useCategories from "~/composables/product/useCategories";
import Breadcrumb from "~/components/common/Molecule/Breadcrumb.vue";
import { LazyInformativeOrganismFooter as LazyFooter } from "#components";
import { LazyInformativeOrganismNavBarMobile as LazyMobileNav } from "#components";
import paths from "~/constants/paths";
import { StaticPage } from "~/types/Data/informative/pages";

const showSideDrawer = ref(false);

const { t } = useI18n();
const route = useRoute();
const { fetchBrands } = useBrands();
const { fetchCategories, fetchCollections, fetchSubCategories } =
  useCategories();

useAsyncData("categories", () => fetchCategories({ include_media: true }));
useAsyncData("sub_categories", () =>
  fetchSubCategories({ include_media: true }),
);
useAsyncData("collections", () => fetchCollections());
useAsyncData("brands", () => fetchBrands(route.query?.categories?.toString()));

const hideBreadcrumb = computed(
  () =>
    route.path === "/" ||
    route.path === "" ||
    route.path.includes("/products") ||
    route.path.includes("/payfort-payment"),
);

const modifiedPath = computed(() => {
  return route.path.includes("register")
    ? paths.register
    : route.path.includes("reset-password")
      ? paths.resetPassword
      : route.path;
});

const breadcrumbItems = computed(() => {
  if (hideBreadcrumb.value) {
    return [];
  }
  const pathSegments = modifiedPath.value.split("/").filter(Boolean);

  return [
    {
      label: t("footer.quick_links.home"),
      path: "/",
    },
    ...pathSegments.map((segment, index) => {
      const label = segment.split("-").join(" ");
      const path = "/" + pathSegments.slice(0, index + 1).join("/");
      return { label, path };
    }),
  ];
});

const quickLinks: StaticPage[] = [
  {
    key: "home",
    title: "Home",
    url: paths.home,
  },
  {
    key: "cart",
    title: "Cart",
    url: paths.cart,
  },
  {
    key: "account",
    title: "Account",
    url: paths.account.index,
  },
  {
    key: "wishlist",
    title: "Wishlist",
    url: paths.wishList,
  },
];
</script>
